export const PHOTO_SESSION_ISSUE_REPORT_VIEWED_ANALYTICS = 'PHOTO_SESSION_ISSUE_REPORT_VIEWED_ANALYTICS';
export const PHOTO_SESSION_ISSUE_REPORT_CLICKED_ANALYTICS = 'PHOTO_SESSION_ISSUE_REPORT_CLICKED_ANALYTICS';
export const PHOTO_SESSION_ISSUE_REPORT_ACTION = 'PHOTO_SESSION_ISSUE_REPORT_ACTION';
export const PHOTO_SESSION_ISSUE_REPORT_UPDATE = 'PHOTO_SESSION_ISSUE_REPORT_UPDATE';
